import { render } from "./TechSection.vue?vue&type=template&id=f59da106"
import script from "./TechSection.vue?vue&type=script&lang=js"
export * from "./TechSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__